import {
  Component,
  OnInit,
  inject,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { MenuModule } from 'primeng/menu';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { MenuItem, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Pagination } from '@app/shared/model';
import { DetalheProfissionaisComponent } from '../../../../../profissionais/detalhe-profissionais/detalhe-profissionais.component';
import { SelectChangeEvent } from 'primeng/select';
import { InputText } from 'primeng/inputtext';
import { Router } from '@angular/router';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { DrawerModule } from 'primeng/drawer';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import {
  VagaService,
  ProfissionalService,
  ProfissaoCatalogoService,
} from '@app/features-modules/bolsa-de-profissionais/services';
import { ApiService } from '@core/providers/http';
import { FilterItem } from '@app/features-modules/gestao-bolseiros/components/api/models/filterItem.model';
import { SectorEnum, ProfissionalListItemDTO, Profissional, ProfissaoCatalogoListItemDTO } from '@app/features-modules/bolsa-de-profissionais/api';
import { DialogModule } from 'primeng/dialog';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SelectModule } from 'primeng/select';


@Component({
  selector: 'app-lista-profissionais',
  standalone: true,
  imports: [
    TagModule,
    TableModule,
    SelectModule,
    MenuModule,
    ButtonModule,
    CommonModule,
    ToastModule,
    DetalheProfissionaisComponent,
    SearchBarComponent,
    InputText,
    DrawerModule,
    PaginatorControlComponent,
    DataVoidComponent,
    DialogModule,
    SelectButtonModule,
    ReactiveFormsModule
  ],
  providers: [
    MessageService,
    ProfissionalService,
    ApiService,
    MessageService,
    VagaService,
    ProfissaoCatalogoService,
  ],
  template: `
    <div class="input_contetnt">
      <app-search-bar
        [showFilterBtn]="true"
        (onFilterBtnClick)="showFilter = true"
        [showPrimaryBtn]="false"
        [sortFields]="sortFields"
        (formValueChange)="onFilterChange($event)"
      ></app-search-bar>
    </div>

    <div *ngIf="pagination?.data?.length; else emptyData">
      <p-table [value]="pagination.data || []" stripedRows="true">
        <ng-template pTemplate="header">
          <tr>
            <th>N.º do BI</th>
            <th>Nome do Profissional</th>
            <th>Função de Referência</th>
            <th>Habilitações</th>
            <th>Estado</th>
            <th>Acções</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-profissional>
          <tr>
            <td>{{ textToUpper(profissional.numBI) }}</td>
            <td>{{ profissional.nome }}</td>
            <td>{{ profissional.especialidadesFuncoes || 'Sem Profissão' }}</td>
            <td>{{ profissional.nivelHabilitacao }}</td>
            <td>
              <p-tag
                *ngIf="profissional.estado === 'Empregado'"
                severity="success"
                value="Empregado"
              ></p-tag>
              <p-tag
                *ngIf="profissional.estado === 'Desempregado'"
                severity="danger"
                value="Desempregado"
              ></p-tag>
            </td>
            <td>
              <div class="flex justify-center">
                <p-menu
                  #menu
                  [model]="getMenuItems(profissional)"
                  [popup]="true"
                  appendTo="body"
                ></p-menu>
                <p-button
                  (click)="menu.toggle($event)"
                  icon="pi pi-ellipsis-v"
                ></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <div class="pagination-controls">
        <app-paginator-control
          [first]="
            ((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)
          "
          [rows]="pagination.pageSize ?? 10"
          [totalRecords]="pagination.totalRecords ?? 0"
          (pageChange)="onPageChange($event)"
        >
        </app-paginator-control>
      </div>
    </div>
    <ng-template #emptyData>
      <div class="no-data">
        <app-data-void
          titulo="Nenhum profissional encontrado"
          descricao="Os profissionais associados a si no SIASP que aparecerão aqui."
        ></app-data-void>
      </div>
    </ng-template>

    <p-drawer
      [(visible)]="visible"
      position="right"
      [style]="{ width: '720px' }"
      styleClass="!w-full md:!w-80 lg:!w-[30rem]"
    >
      <ng-template #headless>
        @if (profissional) {
        <app-detalhe-profissionais
          [profissional]="profissional"
          (onCloseModal)="visible = false"
        />
        }
      </ng-template>
    </p-drawer>
    <p-toast></p-toast>
    <p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">

  <form [formGroup]="form" class="p-fluid grid">
    <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
      <label>{{ filter.placeholder }}</label>

      <!-- Se for dropdown -->
      <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
        [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
        [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
      </p-select>

      <!-- Se for texto -->
      <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
        [placeholder]="filter.placeholder" class="w-full" />
    </div>
  </form>


  <div class="flex items-center justify-content-between">
    <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
    <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
  </div>
</p-dialog>
  `,
  styles: [
    `
      .card {
        display: flex;
        justify-content: center;
      }
    `,
  ],
})
export class ListaProfissionaisComponent implements OnInit {
  @Input('perfilEmpresa') perfilEmpresa: any;
  sortFields: any[] = [
    { label: 'Nome', value: 'nome' },
    { label: 'numero do BI', value: 'NumBI' },
  ];
  messageService = inject(MessageService);
  profissionalService = inject(ProfissionalService);
  profissaoService = inject(ProfissaoCatalogoService);
  visible: boolean = false;
  isLoading: boolean = false;
  profissionais: ProfissionalListItemDTO[] = [];
  profissional: Profissional | undefined | null;
  listaProfissoes: ProfissaoCatalogoListItemDTO[] = [];
  items: MenuItem[] = [
    {
      label: 'Ver  Profissional',
      icon: 'pi pi-desktop',
      command: (event: any) => this.showDetail(event.item.profissional),
    },
  ];
  pagination: Pagination<any> = new Pagination<any>();
  subsector = [
    { id: SectorEnum.NUMBER_1, designacao: 'Petróleo e Gás' },
    { id: SectorEnum.NUMBER_2, designacao: 'Recursos Minerais' },
  ];
  private router = inject(Router);
  @Output() totalProfissionaisChange = new EventEmitter<number>();
  totalProfissionaisl: number = 0;
  showFilter: boolean = false;
  form!: FormGroup;
  constructor(private fb: FormBuilder) { }

  filters: FilterItem[] = [
    {
      type: 'dropdown',
      controlName: 'Estado',
      placeholder: 'Selecione o estado',
      options: [
        { label: 'Empregado', value: 'Empregado' },
        { label: 'Desempregado', value: 'Desempregado' },
      ],
    },

    {
      type: 'text',
      controlName: 'NumBI',
      placeholder: 'Pesquise por n.º identificação',
    },
    {
      type: 'text',
      controlName: 'Nome',
      placeholder: 'Pesquise por nome',
    },
  ];

  // items: MenuItem[] | undefined;

  ngOnInit() {
    this.getProfissionais();
    this.form = this.fb.group({
      Estado: [null],
      NumBI: [null],
      Nome: [null],
    });
  }

  textToUpper(text: string) {
    return text.toUpperCase();
  }

  getMenuItems(profissional: any) {
    return [{ ...this.items[0], profissional }];
  }

  showDetail(item: any) {
    this.profissional = item;
    this.visible = true;
  }

  onChangeSector(item: SelectChangeEvent) {
    let subSector = item.value as SectorEnum;
    this.listaProfissoes = [];
    this.profissaoService.list(subSector).subscribe((result) => {
      if (result.data) {
        this.listaProfissoes = result.data;
      }
    });
  }

  getProfissionais(filters?: any) {
    this.isLoading = true;
    const params = {
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 5,
      EmpresaID: this.perfilEmpresa?.id,
      ...filters,
    };
    this.profissionalService.list(params).subscribe(
      (result) => {
        if (result.data) {
          this.pagination = new Pagination<any>().deserialize(result);
          this.isLoading = false;
          this.totalProfissionaisl = this.pagination.totalRecords ?? 0;
          this.totalProfissionaisChange.emit(this.totalProfissionaisl);
        }
      },
      (error: any) => {
        console.error('Erro ao buscar profissionais:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao buscar profissionais.',
          life: 3000,
        });
        this.isLoading = false;
      }
    );
  }

  onFilterChange(filters: any) {
    this.getProfissionais(filters);
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getProfissionais();
  }
  handleFormValueChange(event: any) {
    const queryParams = Object.fromEntries(
      Object.entries(event).filter(
        ([key, value]) => value !== null && value !== ''
      )
    );
    this.getProfissionais(queryParams);
    this.showFilter = false;
  }
}
